import getConfig from 'next/config';

export default function getCmApiUrl(url) {
    const whitelistUrls = ['car-and-driver-test-np.awsacsnp.autotrader.com', 'www-stage.caranddriver.com'];

    const { publicRuntimeConfig = {} } = getConfig();
    const { environment = 'prod' } = publicRuntimeConfig;

    // Check if running on client side
    const isClientSide = typeof window !== 'undefined';

    // is counted as a 'prod' environment, but fyc-staging is not behind akamai. This should account for both staging and west staging
    const isProdStaging = isClientSide && window?.location?.hostname.includes('fyc-staging');

    // client side prod requests have cm-api prefixed to the url to support Car and Driver brand
    if (isClientSide
            && ((!isProdStaging && environment === 'prod' && process.env.NODE_ENV === 'production' && process.env.LOCAL_PROD !== 'true')
            || whitelistUrls.some((value) => window?.location?.hostname.includes(value)))) {
        return `/cm-api${url}`;
    }

    return url;
}
